import * as React from 'react';
import { CommonProps } from './common.intefaces';
import Select from 'antd/lib/select';

interface IProps extends CommonProps {
  allowedPickupAndDrop: string[];
}

const SelectPickupDrop = (props: IProps) => {

  const {
    mode,
    style,
    value,
    onChange,
    disabled,
    className,
    placeholder,
    allowedPickupAndDrop,
  } = props;

  const renderPDOptions = () => {
    return allowedPickupAndDrop?.map((item) => <Select.Option
      key={item}
    >
      {item}
    </Select.Option>) || [];
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    disabled={disabled}
    allowClear
    showSearch
    value={value}
    onChange={onChange}
    className={className}
    mode={mode || 'default'}
    placeholder={placeholder || 'Select Pickup and Drop'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderPDOptions()}
  </Select>;
};

export default React.memo(SelectPickupDrop);
